import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import { HandThumbsUp, HandThumbsDown } from 'react-bootstrap-icons';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

const Feedback = (props) => {
    const session = useSelector((state) => state.asr.session);
    const [rating, setRating] = useState(0);    

    const notify = () => toast("👍 Thanks for your feedback!");

    // if session is changed, rating will be reset
    useEffect(() => {
        setRating(0);
    }, [session]);

    const setRate = (rate) => {
        rate === rating ? setRating(0) : setRating(rate);
    } 

    // console.log("session: " + session +" type: " + type + " rate: " + rate);     

    const sendFeedback = (type, rate) => {
        if(session === "") return false;

        setRate(rate);        

        const reqBody = {
            "session" : session,
            "type" : type,
            "rate" : rate
        }

        axios
            .post(`${process.env.REACT_APP_BACKEND_URL}/feedback`, reqBody, {
                headers: {
                    "Content-Type": "application/json"
                },
            })
            .then((response) => {
                console.log(response);
                notify();

            })
            .catch((error) => {
                // handle errors
                console.log(error);
                
            });

        return true;
    }

    const getPositiveRating = () => {
        if(rating === 0 || rating === -1) {
            return "black";
        }
        return "blue";
    } 

    const getNegetiveRating = () => {
        if(rating === 0 || rating === 1) {
            return "black";
        }
        return "red";
    } 

    return (
        <div className='button-group-feedback' style={{'float': 'right'}} >   
            <ButtonGroup aria-label="feedback-group">
                <Button variant="outline-dark" title="Good!" size="sm" onClick={(e) => sendFeedback(props.type, 1)}>
                    <HandThumbsUp
                        title="Good!" 
                        className='feedback-yes-btn'
                        color={ getPositiveRating() }
                        size={16} />
                </Button>
                <Button variant="outline-dark" title="Bad!" size="sm" onClick={(e) => sendFeedback(props.type, -1)}>
                    <HandThumbsDown
                        title="Bad!" 
                        className='feedback-no-btn'
                        color={ getNegetiveRating() } 
                        size={16} />
                </Button>
            </ButtonGroup>     
        </div>
    );
};

export default Feedback;